module.exports = __webpack_public_path__ + "img/serdika-ruins.f4c3f49d.jpg";